import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let TourComp;

class Tour extends Route {
    render() {
       return { outlet: '#zcatcomponent', component: TourComp };
   }


    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(
            import(/* webpackChunkName: "components/javascript/zcat-components/tour-comp" */
            "../../../components/javascript/zcat-components/tour-comp").then(function(res) {
                TourComp = res.TourComp;
            })
        );

        
;
    }
}

export {Tour};

